<div class="schedule-slot-preset-editor" [formGroup]="presetForm">
    <app-frosty-dialog-shell
        [eyebrow]="'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Title' | translate"
        [title]="(isEditMode
            ? 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.EditPreset'
            : 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.CreatePreset') | translate"
        [description]="'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetEditorDescription' | translate"
        bodyClass="grid gap-4">
            <button
                dialog-actions
                type="button"
                mat-icon-button
                class="shrink-0 rounded-md border border-white/60 bg-white/60"
                [disabled]="isDeleting"
                [attr.aria-label]="'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.Cancel' | translate"
                (click)="close()">
                <fa-icon [icon]="['fal','times']"></fa-icon>
            </button>

            <app-form-section-card
                [title]="'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetDetailsTitle' | translate"
                [description]="'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetDetailsDescription' | translate">
                <div class="grid gap-3 md:grid-cols-2">
                    <mat-form-field class="w-full frosty">
                        <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetName' | translate }}</mat-label>
                        <input matInput formControlName="name" />
                    </mat-form-field>

                    <mat-form-field class="w-full frosty">
                        <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetDescription' | translate }}</mat-label>
                        <input matInput formControlName="description" />
                    </mat-form-field>

                    <mat-form-field class="w-full frosty">
                        <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetStartDate' | translate }}</mat-label>
                        <input matInput type="date" formControlName="startDate" />
                    </mat-form-field>

                    <mat-form-field class="w-full frosty">
                        <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetEndDate' | translate }}</mat-label>
                        <input matInput type="date" formControlName="endDate" />
                    </mat-form-field>
                </div>
            </app-form-section-card>

            <app-form-section-card
                [title]="'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetSlotTitle' | translate"
                [description]="'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetSlotDescription' | translate"
                [headerInline]="true">
                <button
                    section-actions
                    type="button"
                    app-wizard-action-button="secondary"
                    size="small"
                    (click)="addSlot()">
                    <fa-icon [icon]="['fal','plus']"></fa-icon>
                    {{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.AddSlot' | translate }}
                </button>

                <div formArrayName="slots" class="grid gap-3">
                    <article
                        *ngFor="let slot of slotArray.controls; let i = index"
                        [formGroupName]="i"
                        class="rounded-md border border-white/60 bg-white/50 p-3">
                        <div class="mb-3 flex items-center justify-between gap-3">
                            <div class="flex min-w-0 items-center gap-3">
                                <span class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-white/60 bg-white/60 text-sm font-semibold text-slate-700">
                                    {{ i + 1 }}
                                </span>
                                <span class="truncate text-sm font-semibold text-slate-950">
                                    {{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetSlotLabel' | translate }}
                                </span>
                            </div>

                            <button
                                type="button"
                                mat-icon-button
                                class="rounded-md border border-rose-100 bg-rose-50/70 text-rose-600"
                                (click)="removeSlot(i)"
                                [disabled]="slotArray.length === 1"
                                [attr.aria-label]="'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.RemoveSlot' | translate">
                                <fa-icon [icon]="['fal','trash-alt']"></fa-icon>
                            </button>
                        </div>

                        <div class="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
                            <mat-form-field class="w-full frosty">
                                <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetMode' | translate }}</mat-label>
                                <mat-select formControlName="mode" [disabled]="isSingleSlotMode" (selectionChange)="onModeChange(i)">
                                    <mat-option *ngIf="isSlotModeSupported(1)" [value]="1">
                                        {{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.ModePoint' | translate }}
                                    </mat-option>
                                    <mat-option *ngIf="isSlotModeSupported(2)" [value]="2">
                                        {{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.ModeRange' | translate }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="w-full frosty">
                                <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetFrequency' | translate }}</mat-label>
                                <mat-select formControlName="frequency" (selectionChange)="onFrequencyChange(i)">
                                    <mat-option *ngFor="let option of frequencyOptions" [value]="option.value">
                                        {{ option.labelKey | translate }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <ng-container [ngSwitch]="slot.get('frequency')?.value">
                                <mat-form-field class="w-full frosty" *ngSwitchCase="2">
                                    <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetDayOfWeek' | translate }}</mat-label>
                                    <mat-select formControlName="dayOfWeek">
                                        <mat-option *ngFor="let option of dayOfWeekOptions" [value]="option.value">
                                            {{ option.labelKey | translate }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="w-full frosty" *ngSwitchCase="3">
                                    <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetDayOfMonth' | translate }}</mat-label>
                                    <input matInput type="number" min="1" max="31" formControlName="dayOfMonth" />
                                </mat-form-field>

                                <ng-container *ngSwitchCase="4">
                                    <mat-form-field class="w-full frosty">
                                        <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetMonth' | translate }}</mat-label>
                                        <mat-select formControlName="monthOfYear">
                                            <mat-option *ngFor="let option of monthOptions" [value]="option.value">{{ option.label }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field class="w-full frosty">
                                        <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetDayOfMonth' | translate }}</mat-label>
                                        <input matInput type="number" min="1" max="31" formControlName="dayOfMonth" />
                                    </mat-form-field>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="slot.get('frequency')?.value === 6; else standardTimePicker">
                                <mat-form-field class="w-full frosty">
                                    <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetStartTime' | translate }}</mat-label>
                                    <mat-select formControlName="startTime">
                                        <mat-option *ngFor="let minute of minuteOptions" [value]="'00:' + minute">
                                            {{ minute }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="w-full frosty" *ngIf="slot.get('mode')?.value === 2">
                                    <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetEndTime' | translate }}</mat-label>
                                    <mat-select formControlName="endTime">
                                        <mat-option *ngFor="let minute of minuteOptions" [value]="'00:' + minute">
                                            {{ minute }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-container>

                            <ng-template #standardTimePicker>
                                <mat-form-field class="w-full frosty">
                                    <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetStartTime' | translate }}</mat-label>
                                    <input matInput type="time" formControlName="startTime" />
                                </mat-form-field>

                                <mat-form-field class="w-full frosty" *ngIf="slot.get('mode')?.value === 2">
                                    <mat-label>{{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.PresetEndTime' | translate }}</mat-label>
                                    <input matInput type="time" formControlName="endTime" />
                                </mat-form-field>
                            </ng-template>
                        </div>
                    </article>
                </div>
            </app-form-section-card>

        <footer dialog-footer class="flex flex-col gap-2 border-t border-white/50 pt-3">
            <p *ngIf="deleteErrorMessage" class="text-sm text-rose-600">
                {{ deleteErrorMessage }}
            </p>

            <div class="flex flex-col-reverse gap-2 sm:flex-row sm:items-center sm:justify-between">
                <button
                    *ngIf="isEditMode"
                    type="button"
                    app-wizard-action-button="danger"
                    [busy]="isDeleting"
                    [disabled]="isSaving || isDeleting"
                    (click)="deletePreset()">
                    <fa-icon [icon]="['fal','trash-alt']"></fa-icon>
                    {{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.DeletePreset' | translate }}
                </button>

                <span *ngIf="!isEditMode" class="hidden sm:block"></span>

                <div class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
                    <button
                        type="button"
                        app-wizard-action-button="secondary"
                        [disabled]="isDeleting"
                        (click)="close()">
                        {{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.Cancel' | translate }}
                    </button>
                    <button
                        type="button"
                        app-wizard-action-button="success"
                        [busy]="isSaving"
                        [disabled]="presetForm.invalid || isSaving || isDeleting"
                        (click)="save()">
                        {{ 'SystemAdmin.Components.CustomReportEditor.Tab.Schedule.Form.SavePreset' | translate }}
                    </button>
                </div>
            </div>
        </footer>
    </app-frosty-dialog-shell>
</div>
